module.exports = __webpack_public_path__ + "static/media/191CS242.ea0dd93b.jpg";